import Meeting from '@/components/Meeting/Meeting';
import { useFetchUserDataQuery } from '@/store/apis/userApi';
import { Modal, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

interface MeetingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onOk: () => void;
}

const MeetingModal: React.FC<MeetingModalProps> = ({
  isOpen,
  onClose,
  onOk,
}) => {
  const { data: userProfileData, refetch } = useFetchUserDataQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const userProfile = userProfileData?.data;

  const [meetingLink, setMeetingLink] = useState('');

  useEffect(() => {
    if (!userProfile) return;
    const params = new URLSearchParams({
      embed: 'true',
      ...(userProfile?.firstName && { firstname: userProfile?.firstName }),
      ...(userProfile?.lastName && { lastname: userProfile?.lastName }),
      ...(userProfile?.email && { email: userProfile?.email }),
      ...(userProfile?.phone && { phone: userProfile?.phone }),
    });
    setMeetingLink(
      `https://meetings.hubspot.com/odin-mortgage/strategy-meeting-refinance?${params}`,
    );
  }, [userProfile]);

  return (
    <Modal
      onOk={onOk}
      open={isOpen}
      onCancel={onClose}
      width={1000}
      cancelText="Close"
      okText="Done"
      footer={null}
      title={
        <Typography.Title level={4}>
          Do you want to book a meeting?
        </Typography.Title>
      }
    >
      <Meeting meetingUrl={meetingLink} />
    </Modal>
  );
};

export default MeetingModal;
